var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionCheckboxOn = function SvgGeneralActionCheckboxOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M19 21.334H5A2.334 2.334 0 0 1 2.667 19V5A2.333 2.333 0 0 1 5 2.667h14a2.333 2.333 0 0 1 2.334 2.334v14A2.334 2.334 0 0 1 19 21.334"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.11 16.782-4.448-4.448 1.336-1.336 3.112 3.111 6.892-6.891 1.337 1.336z"
  }))));
};
export default SvgGeneralActionCheckboxOn;